import { ReactComponent as IconDirection } from 'assets/icons/icon-directions.svg';
import TextInput from 'components/text-input';
import { nanoid } from 'nanoid';
import React, { useState } from 'react';
import { usePlacesWidget } from 'react-google-autocomplete';
import { AutoCompleteLink, Label, Wrapper } from './auto-complete.styles';

interface Props {
  address?: string;
  label?: string;
  errors?: any;
  onChange?: (value: string) => void;
}

const AutoComplete = React.forwardRef<HTMLDivElement, Props>(
  ({ label, onChange, address = '' }, forwardedRef) => {
    const [currentAddress, setCurrentAddress] = useState<string>(address || '');
    const [addressUrl, setAddressUrl] = useState<string>(
      `https://maps.google.com/?q=${address.replaceAll(' ', '+')}`
    );

    const uniqueid = `id${nanoid()}`;

    const { ref } = usePlacesWidget<HTMLInputElement>({
      apiKey: process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY,
      onPlaceSelected: (place: any) => {
        setCurrentAddress(place.formatted_address);
        setAddressUrl(
          `https://maps.google.com/?q=${place.formatted_address.replaceAll(
            ' ',
            '+'
          )}`
        );
        onChange && onChange(place.formatted_address);
      },
      options: {
        types: ['address'],
        componentRestrictions: { country: 'au' },
      },
    });

    return (
      <Wrapper id={uniqueid} ref={forwardedRef}>
        {label && <Label htmlFor={uniqueid}>{label}</Label>}
        <TextInput
          ref={ref}
          placeholder='Enter an address or name'
          defaultValue={currentAddress}
          onChange={(value: any) => {
            setCurrentAddress(value.target.value);
          }}
          onBlurCapture={() => {
            onChange && onChange(currentAddress);
            setAddressUrl(
              `https://maps.google.com/?q=${currentAddress.replaceAll(
                ' ',
                '+'
              )}`
            );
          }}
        />
        <AutoCompleteLink
          href={addressUrl}
          target='_blank'
          aria-disabled={!currentAddress}
          isDisabled={!currentAddress}
        >
          <IconDirection className='directions' />
        </AutoCompleteLink>
      </Wrapper>
    );
  }
);

export default AutoComplete;
